export default __webpack_public_path__ + "img/423449c0d2f61936dbfc42bc4de201e0.svg";